import { useEffect } from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';
import UsKanban from '../components/UsKanban';
import { useUpdates } from '../context/UpdatesContext';
import { useT } from '../i18n/useT';

export default function DashboardScreen() {
  // CCT-348 — the board is read by being opened; and moving a card oneself must not come
  // back as an update, hence the second mark on leaving.
  const { markSeen } = useUpdates();
  useEffect(() => { markSeen('board'); return () => markSeen('board'); }, [markSeen]);
  const t = useT();
  const { isDarkTheme } = useTheme();
  const colors = getThemeColors(isDarkTheme);
  const { user } = useAuth();

  const userName = user
    ? `${user.prenom || ''}${user.nom ? ' ' + user.nom : ''}`.trim() || t('dashboard.defaultUser')
    : t('dashboard.defaultUser');

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.background }]}>
      {/* Colonne PLEINE HAUTEUR (pas de ScrollView vertical) : c'est le kanban qui défile, si
          bien que sa barre de défilement horizontale et le volet arrivent en pied de page. */}
      <View style={[styles.content, { backgroundColor: colors.background }]}>
        <View style={styles.header}>
          <Text style={[styles.headerTitle, { color: colors.textPrimary }]}>
            {t('dashboard.hello', { name: userName })}
          </Text>
          <Text style={[styles.headerSubtitle, { color: colors.textSecondary }]}>
            {t('dashboard.yourTasks')}
          </Text>
        </View>

        {/* Kanban des US, toutes missions (CCT-98) : le tableau de bord est l'endroit où le
            joueur voit son travail transverse — la timeline d'un chapitre reste par mission.
            Les listes de missions ont été retirées : elles doublonnaient l'écran Missions. */}
        <View style={styles.section}>
          <UsKanban />
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  content: { flex: 1, minHeight: 0, padding: 16 },
  header: { marginBottom: 16 },
  headerTitle: { fontSize: 24, fontWeight: 'bold', marginBottom: 4 },
  headerSubtitle: { fontSize: 15 },
  section: { flex: 1, minHeight: 0 },
  sectionHeader: { flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 14 },
  sectionTitle: { fontSize: 18, fontWeight: '700', flex: 1 },
  countBadge: { paddingHorizontal: 9, paddingVertical: 3, borderRadius: 10 },
  countText: { fontSize: 13, fontWeight: '700' },
  emptyCard: { borderRadius: 12, padding: 24, alignItems: 'center', gap: 10, shadowColor: '#000', shadowOffset: { width: 0, height: 1 }, shadowOpacity: 0.08, shadowRadius: 3, elevation: 2 },
  emptyText: { fontSize: 14, textAlign: 'center' },
  missionCard: { borderRadius: 12, padding: 16, marginBottom: 12, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 },
  missionCardTop: { flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12, gap: 8 },
  missionInfo: { flex: 1 },
  missionTitle: { fontSize: 15, fontWeight: '700', marginBottom: 3 },
  missionSubtitle: { fontSize: 12, lineHeight: 16 },
  certBadge: { flexDirection: 'row', alignItems: 'center', gap: 4, paddingHorizontal: 8, paddingVertical: 4, borderRadius: 8, flexShrink: 0 },
  certBadgeText: { fontSize: 11, fontWeight: '700' },
  completedBadge: { flexDirection: 'row', alignItems: 'center', gap: 4, paddingHorizontal: 8, paddingVertical: 4, borderRadius: 8, flexShrink: 0 },
  completedBadgeText: { fontSize: 11, fontWeight: '700' },
  progressRow: { flexDirection: 'row', alignItems: 'center', gap: 10, marginBottom: 12 },
  progressBar: { flex: 1, height: 8, borderRadius: 4, overflow: 'hidden' },
  progressFill: { height: '100%' as any, borderRadius: 4 },
  progressLabel: { fontSize: 12, fontWeight: '700', minWidth: 36, textAlign: 'right' },
  missionFooter: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  metaRow: { flexDirection: 'row', alignItems: 'center', gap: 4 },
  metaText: { fontSize: 12 },
  continueBtn: { flexDirection: 'row', alignItems: 'center', gap: 4 },
  continueBtnText: { fontSize: 13, fontWeight: '600' },
  certButton: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 8, paddingVertical: 10, paddingHorizontal: 16, borderRadius: 8 },
  certButtonText: { color: '#FFFFFF', fontSize: 14, fontWeight: '600' },
});
